import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { css } from '@bd/bdui-styles';
import 'react-datepicker/dist/react-datepicker.css';
import { colors } from '../../../styles';

const styles = css`
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    width: 100%;
    input {
      width: 100% !important;
      border: 1px solid ${colors.neutral};
      padding: 0 15px;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: ${colors.body};
      @media(min-width: 576px) {
        width: 49%;
        background-image: url(/images/icons/icon-arrow-down.svg);
        background-position: calc(100% - 20px) center;
        background-repeat: no-repeat;
        cursor: pointer;
      }
    }
  }
  ul.react-datepicker__time-list {
    padding: 0 !important;
  }
  .react-datepicker__time-container {
    width: 90px;
  }
  .react-datepicker__time-box {
    width: 80px !important;
  }
  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 90px !important;
  }
`;

class DateField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
    };
  }

  handleChange = date => {
    this.setState({
      startDate: date,
    }, () => {
      this.props.formApi.setValue(this.props.field, date.format('dddd, MMMM Do YYYY, HH:mm a'));
    });
  }

  render() {
    const {
      className,
      field,
      label,
      placeholder,
      required,
      getErrorClass,
      getError,
    } = this.props;

    const {
      startDate,
    } = this.state;

    return (
      <div className={[styles, className].filter(v => v).join(' ')}>
        {
          label &&
          <label htmlFor={field}>
            {label}
            {
              required &&
              <span className="required"> *</span>
            }
          </label>
        }
        <DatePicker
          className={`form-control ${getErrorClass(field)}`}
          shouldCloseOnSelect
          selected={startDate}
          minTime={moment().hours(10).minutes(0)}
          maxTime={moment().hours(17).minutes(0)}
          onChange={this.handleChange}
          dateFormat="MMMM D, YYYY"
          placeholderText={placeholder}
        />
        <div className="invalid-feedback">
          {getError(field)}
        </div>
      </div>
    );
  }

}

DateField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  // requiredMessage: PropTypes.string,
  getErrorClass: PropTypes.func.isRequired,
  getError: PropTypes.func.isRequired,
  formApi: PropTypes.object.isRequired,
};

DateField.defaultProps = {
  className: undefined,
  label: undefined,
  placeholder: undefined,
  required: false,
  requiredMessage: undefined,
};

export default DateField;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/Date.js